export const luckDrawData = (moduleItem) => {
  let formData = {
    activityId: moduleItem.activityId,
    moduleId: moduleItem.moduleId,
    prizeList: []
  };

  moduleItem.activityModuleDetail.forEach((item1) => {
    let obj = formData.prizeList.find((item2) => item2.moduleGroupCode == item1.moduleGroupCode);
    if (obj) {
      obj[item1.moduleDetailCode] = item1.moduleDetailCode == 'bakImg' ? (item1.moduleDetailValue ?  [{url: item1.moduleDetailValue}] : []) : item1.moduleDetailValue
      obj.fieldId.push({[item1.moduleDetailCode]: item1.moduleDetailId })
    } else {
      formData.prizeList.push({
        moduleGroupCode: item1.moduleGroupCode,
        [item1.moduleDetailCode]: item1.moduleDetailCode == 'bakImg' ? ( item1.moduleDetailValue ?  [{url: item1.moduleDetailValue}] : [] ) : item1.moduleDetailValue,
        fieldId: [{[item1.moduleDetailCode]: item1.moduleDetailId }],
        isReplace: true,
      });
    }
  });
  return formData;
};

export const formValidation = (list) => {
  let isAdopt = true
  const lottery = list.find(item => item.comType == 'lottery')
  if (!lottery) return isAdopt
  try {
    lottery.formData.prizeList.forEach(item => {
      let typeList = item.awardType == 'redPack' ? 
                    ['awardName','isNewAdd','fieldId','isReplace' ] : 
                    ['singleAmount','isNewAdd','fieldId','isReplace']
      for(let [key,value] of Object.entries(item)) {
        if (!typeList.includes(key)) {
          if(!value){
            isAdopt = false
            throw new Error('false')
          }
        }
      }
    
    })
  } catch(e) {
    if (e == 'false' ) throw  e
  }
  return isAdopt
}


export function getFissionDTO(fissionData) {
  const fields = [];
  for(const [key, value] of Object.entries(fissionData)) {
    fields.push({
      elementCode: key,
      elementValue: value
    })
  }
  return fields
}

// 初始化裂变其他配置
export function initFissionForm(activityAppend,type) {
  let fileds = {}
  let fission = activityAppend.find(item => item.appendName === type)
  if (!fission) return fileds
  fission.activityAppendElement.forEach(item => {
    if (item.elementCode.startsWith('bool')) {
      fileds[item.elementCode] =  JSON.parse(item.elementValue)
    }else {
      fileds[item.elementCode] = item.elementValue
    }
  });
  return fileds
}


// 初始化抽奖其他配置
export function formatDataLottery(dataList) {
  let obj = {};
  dataList.forEach((item) => {
    obj[item.setupColumn] =  item.setupColumn.startsWith('bool') ? JSON.parse(item.setupColumnValue) : item.setupColumnValue;
  });
  return obj;
}

// 秒杀参数验证
export function paramesVerification(dataList, type) {
  let map = {
    startTime: "开始时间",
    endTime: '结束时间',
    boolVerification: '本场是否自动核销',
    boolPrePay: '本场使用秒杀定金'
  }
  const comItem = dataList.find(item => item.comType == type)
  if (!comItem) return
  let noParmesVft = [
    'activityId','sectionId','goodsId','originalGoogsNumber',
    'sectionLimit','virtualNumber','goodsLimit',
    'goodsTag','detailsImg','headImg','goodsDetails',
    'writeOff','goodDetailOne','goodDetailTwo','goodDetailThree',
    'goodDetailFour','goodDetailFive','goodDetailSix','goodDetailSeven','preSpikePrice'
  ]
  let isAdopt = true
  let title = ''
  try {
  function recursion(arr) {
    arr.forEach((item,index) => {
      for(let [key,value] of Object.entries(item)) {
        if (!Array.isArray(value)) {
          if (!noParmesVft.includes(key)){
            if (value ==='') {
              isAdopt = false
              title = `场次${index+1}的${map[key]}不能为空`
              throw new Error('false')
            }
          }
        }else {
          recursion(value)
        }
        // if (!noParmesVft.includes(key)){
        //   console.log(key,value)
        //   if (value == '') isAdopt = false
        // }
      }
    })
  }
  recursion(comItem.formData.spikeSections)
  } catch (e) {
    if (e == 'false' ) throw  e
  }
  return {isAdopt, title}
}

// 秒杀时间验证
export function spikeTimeVerification(dataList,type,basicInfoForm) {
  const comItem = dataList.find(item => item.comType == type)
  let timeAdopt = true
  let title = ''
  if (!comItem) return
  try {
    const {startTime,endTime } = basicInfoForm
    let activeStartTime = startTime.split(" ").length > 1 ? startTime : startTime + " 00:00:00";
    let activeEndTime = endTime.split(" ").length > 1 ? endTime : endTime + " 23:59:59";
    comItem.formData.spikeSections.forEach((item,index) => {
      if (new Date(item.startTime).getTime() < new Date(activeStartTime).getTime()) {
        timeAdopt = false
        title = `场次${index+1}的秒杀开始时间不能小于活动开始时间`
        throw new Error('false')
      }else if (new Date(item.startTime).getTime() > new Date(activeEndTime).getTime()) {
        timeAdopt = false
        title = `场次${index+1}的秒杀开始时间不能大于活动结束时间`
      }else if (new Date(item.endTime).getTime() > new Date(activeEndTime).getTime()) {
        timeAdopt = false
        title = `场次${index+1}的秒杀结束时间不能大于活动结束时间`
      }
    })
  }catch(e) {
    if (e == 'false' ) throw  e
  }
  return {timeAdopt,title}
}

// 秒杀编辑 克隆 草稿箱数据处理
export function initspikeData(moduleItem, isClone = false) {
  if (!moduleItem.spikeSections) return []
  moduleItem.spikeSections.forEach(item => {
    item.writeOff = item.boolVerification == 'true' ? '是' : '否'
    item.boolPrePayName = item.boolPrePay == 'true' ? '是' : '否'
    if (isClone) item.sectionId = ''
    if (item.spikeGoods) {
     item.spikeGoods.forEach(goodsItem => {
        if (isClone) goodsItem.goodsId = ''
        if (isClone) goodsItem.sectionId = ''
        goodsItem.headImgList = []
        goodsItem.headImgList.push({url:goodsItem.headImg})
        if (goodsItem.goodsDetails.length) {
          goodsItem.detailsImg = []
          goodsItem.goodsDetails.forEach(img => {
            goodsItem.detailsImg.push({url: img})
          })
        }else {
          goodsItem.detailsImg = []
        }
     })
    }
  })
  return moduleItem
}
// 拼图必传参数验证
export function connectPicVerification(list) {
  let isAdopt = true
  const connectPicData = list.find(item => item.comType == 'connectPic')
   // 是否有抽奖项目
  let isHaslottery = list.some(item => item.comType === 'lottery');
  if (!connectPicData) return false
  let typeList =  isHaslottery ? ['signUpSendCount'] : ['sendLotteryTimes','lotteryChanceType','signUpSendCount']
  for (let [key,value] of Object.entries(connectPicData.formData)) {
    if (!typeList.includes(key)) {
      if (value === '') isAdopt = false
    }
  }
  return isAdopt
}

// 拼团编辑 克隆 草稿箱数据处理
export function initGroupBuyingData(moduleItem,isClone = false) {
  if (!moduleItem.groupBuyingVO) return moduleItem
  if (isClone) {
    moduleItem.groupBuyingVO.activityId = ''
    moduleItem.groupBuyingVO.groupId = ''
  }
  if (moduleItem.groupBuyingVO.goods && moduleItem.groupBuyingVO.goods.length) {
    moduleItem.groupBuyingVO.goods.forEach(item => {
      if (isClone) {
        item.goodsId = ''
        item.activityId = ''
        item.groupId = ''
        item.status = ''
      }
      item.detailsImg = []
      item.headImgList = []
      item.headImgList.push({url:item.headImg})
      if (item.goodsDetails && item.goodsDetails.length) {
        item.goodsDetails.forEach(img => {
          item.detailsImg.push({url: img})
        })
      }
    })
  } else {
    moduleItem.groupBuyingVO.goods = []
  }
 
  return moduleItem
}
